const CV_VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;

class CarVerticalVinGate extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.affiliateUrl = this.dataset.affiliateUrl || '';
    this.affiliateUid = this.dataset.affiliateUid || '109';

    this.triggerForm = this.querySelector('[data-cv-vin-form]');
    this.vinInput = this.querySelector('[data-cv-vin-input]');
    this.errorMessage = this.querySelector('[data-cv-error]');
    this.modal = this.querySelector('[data-cv-modal]');
    this.noVinButton = this.querySelector('[data-cv-no-vin]');
    this.leadForm = this.querySelector('.cv-gate-form');
    this.hiddenFrame = this.querySelector('[data-cv-frame]');

    this.formSubmitted = false;
    this.redirectStarted = false;
    this.pendingVin = '';

    if (!this.triggerForm || !this.vinInput || !this.modal) return;

    this.vinInput.addEventListener('input', this.handleVinInput.bind(this));
    this.triggerForm.addEventListener('submit', this.handleTriggerSubmit.bind(this));

    this.noVinButton?.addEventListener('click', () => {
      this.pendingVin = '';
      this.openModal();
    });

    this.leadForm?.addEventListener('submit', this.handleLeadSubmit.bind(this));

    this.hiddenFrame?.addEventListener('load', () => {
      if (this.formSubmitted) {
        setTimeout(() => this.redirectToCarVertical(), 250);
      }
    });

    this.querySelectorAll('[data-cv-close]').forEach((button) => {
      button.addEventListener('click', this.closeModal.bind(this));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.closeModal();
      }
    });
  }

  getVin() {
    return this.vinInput.value.trim().toUpperCase();
  }

  handleVinInput() {
    this.vinInput.value = this.vinInput.value
      .toUpperCase()
      .replace(/[^A-HJ-NPR-Z0-9]/g, '')
      .slice(0, 17);

    if (this.errorMessage) this.errorMessage.style.display = 'none';
  }

  handleTriggerSubmit(event) {
    event.preventDefault();

    const vin = this.getVin();

    if (!CV_VIN_PATTERN.test(vin)) {
      if (this.errorMessage) this.errorMessage.style.display = 'block';
      return;
    }

    this.pendingVin = vin;
    this.openModal();
  }

  handleLeadSubmit() {
    this.formSubmitted = true;
    this.tagOneSignal();

    const submitButton = this.leadForm?.querySelector('.cv-gate-submit');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Redirecting...';
    }

    // Fallback in case the hidden Shopify form does not trigger an iframe load.
    this.redirectTimer = setTimeout(
      () => this.redirectToCarVertical(),
      6000
    );
  }

  tagOneSignal() {
    window.OneSignalDeferred = window.OneSignalDeferred || [];

    window.OneSignalDeferred.push((OneSignal) => {
      try {
        const tags = { signup_source: 'carvertical-vin-gate' };

        if (this.pendingVin) tags.VIN = this.pendingVin;

        OneSignal.User.addTags(tags);
      } catch (err) {
        console.warn('[carvertical-vin-gate] OneSignal tag write failed:', err);
      }
    });
  }

  openModal() {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      const emailInput = this.leadForm?.querySelector('.cv-gate-email');
      emailInput?.focus();
    }, 150);
  }

  closeModal() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
  }

  buildAffiliateUrl() {
    const baseUrl =
      this.affiliateUrl ||
      'https://www.carvertical.deal/JNS98R/83KB7S/?uid=109&source_id=AFF&sub1=caristaeu&sub2=shopify&sub3=';

    const url = new URL(baseUrl, window.location.href);

    url.searchParams.set('uid', this.affiliateUid || '109');
    url.searchParams.set('source_id', 'AFF');
    url.searchParams.set('sub1', 'caristaeu');
    url.searchParams.set('sub2', 'shopify');
    url.searchParams.set('sub3', this.pendingVin);

    return url.toString();
  }

  redirectToCarVertical() {
    if (this.redirectStarted) return;

    this.redirectStarted = true;
    clearTimeout(this.redirectTimer);

    const url = this.buildAffiliateUrl();

    if (window.Shopify && window.Shopify.designMode) {
      window.open(url, '_blank', 'noopener');
      return;
    }

    try {
      window.top.location.href = url;
    } catch (error) {
      window.location.href = url;
    }
  }
}

if (!customElements.get('carvertical-vin-gate')) {
  customElements.define('carvertical-vin-gate', CarVerticalVinGate);
}